import type { TailwindColor } from 'src/utils/getColor'

export const COMMON_COLORS = {
  base: 'shark-900',
  error: 'sunset-500',
  neutral: 'shark-600',
  success: 'malachite-400',
  warning: 'ochre-500',
} as const satisfies Record<string, TailwindColor>

export const PRODUCT_COLORS = {
  beige: 'stock-500',
  blue: 'saving-500',
  brown: 'loan-500',
  cyan: 'asv-500',
  darkBlue: 'retirement-500',
  default: 'other-500',
  green: 'securities-500',
  grey: 'shark-500',
  lemon: 'pro-500',
  lightGreen: 'realestate-500',
  orange: 'pea-500',
  pink: 'protection-500',
  purple: 'cc-500',
  red: 'sunset-500',
} as const satisfies Record<string, TailwindColor>
